<div class="chart-container">
  <canvas [id]="chartId" #canvas></canvas>
</div>
